// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c232df0a","389":"99d2b712","455":"c28f2306","970":"1e5b3939","977":"5443e408"}[chunkId] + ".chunk.js";
};